import * as React from "react";
import { GradientCard } from "@/components/ui/gradient-card";
import { cn } from "@/lib/utils";

export type IntegrationItem = {
  title: string;
  description: string;
  href: string;
  /** Illustration in the card's bottom-left corner. */
  image: string;
};

/**
 * A heading over a grid of soft cards, one per product surface.
 * Each card is a link to that product's page.
 */
export default function Integrations({
  title,
  description,
  items,
  className,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  items: IntegrationItem[];
  className?: string;
}) {
  return (
    <section className={cn("py-24 sm:py-32", className)}>
      <div className="mx-auto max-w-[1160px] px-6 sm:px-10">
        <div className="max-w-[640px]">
          <h2 className="text-balance text-[1.5rem] font-extrabold leading-[1.5] tracking-[-0.02em] text-ink-950 sm:text-[1.75rem] md:text-[2rem] md:leading-[1.4]">
            {title}
          </h2>
          {description && (
            <p className="mt-4 text-pretty text-[15px] leading-[1.95] text-ink-600 sm:text-[16px] sm:leading-[1.9]">
              {description}
            </p>
          )}
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <GradientCard
              key={item.title}
              className="min-h-[19rem]"
              title={item.title}
              description={item.description}
              ctaText="بیشتر بدانید"
              ctaHref={item.href}
              imageUrl={item.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
